export default "__VITE_ASSET__Dv45VHbh__"